import {
    API_WEATHER_KEY,
    API_WEATHER_URL
} from '@/scripts/config/weather.config'

import {API} from '@/scripts/common/api/api.services'

const CLASS_PRE = 'weather-info'
export default class Weather {
    constructor(container) {
        this.$container = container
        this.$title = this.$container.querySelector(`.${CLASS_PRE}__title`)
        this.$value = this.$container.querySelector(`.${CLASS_PRE}__val`)
        this.cityName = this.$container.dataset.city || 'rome'
        this.weatherData = null
        this.APIService = null
        this._init()
    }
    _init() {
        this.APIService = new API.Controller()
        this.getWeatherData()
    }

    async getWeatherData() {
       const data = await this.APIService.get(`${API_WEATHER_URL}?q=${this.cityName}&type=hour&mode=json&units=metric&appid=${API_WEATHER_KEY}`)
       this.weatherData = data
       this.updateHTML()
    }

    calculateTime() {
        const d = new Date()

        let localTime = d.getTime(),
        localOffset = d.getTimezoneOffset() * 60000,
        utc = localTime + localOffset,
        destTime = utc + (1000 * this.weatherData.timezone)

        //return new Date(destTime).toGMTString()
        return `${moment(new Date(destTime).toGMTString()).format('hh:mm')} GMT${moment(new Date(destTime).toGMTString()).format('Z')}`
    }

    updateHTML() {
        this.$title.innerHTML = `${this.cityName}`
        this.$title.style.textTransform = 'capitalize'
        this.$value.innerHTML = `${this.weatherData.main.temp}&#176;C (${this.celsiusToFaranheit(this.weatherData.main.temp)}F) ${this.calculateTime()}`
    }
    

    //utilities
    celsiusToFaranheit(c) {
        return Math.round((c*1.8)+32)
    }

    
}